import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import IndustrialHero from './components/IndustrialHero';
import IndustrialServices from './components/IndustrialServices';
import IndustrialCTA from './components/IndustrialCTA';

const IndustrialServicesPage = () => {
  useEffect(() => {
    document.title = 'Industrial Electrical Services Perth | NS Electrical WA';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <IndustrialHero />
        <IndustrialServices />
        <IndustrialCTA />
      </main>
      <Footer />
    </div>
  );
};

export default IndustrialServicesPage;